import { Routes, Route } from "react-router-dom";
import './App.css'
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home"

function DefaultLayout({children}) {

  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function App() {

  return (
    <>
        <main id="wrapper">
          <Routes>
            <Route path="/" element={ <DefaultLayout> <Home /> </DefaultLayout> } />
          </Routes>
        </main>
    </>
  )
}

export default App;
